import { render, staticRenderFns } from "./echarts_proportion_admin.vue?vue&type=template&id=3c2b3ed9"
import script from "./echarts_proportion_admin.vue?vue&type=script&lang=js"
export * from "./echarts_proportion_admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports